<template>

    <div v-if="showLayout" class="app">

        <AppHeader />
        <Sidebar v-if="route.name !== 'receiveSubcontract'" />

        <main id="main-container">
            <div class="container-fluid relative z-10" style="margin-top: 55px;">
                <notPaid />
                <!-- <Transition name="fade">
                    <router-view :id="route.name" class="main-content" :class="routesWithoutSpacing.has(route.name) ? '' : 'p-24 md-p-16'"></router-view>
                </Transition> -->
                <router-view v-slot="{ Component, route }">
                    <Transition name="fade" mode="out-in">
                        <component 
                            :is="Component" 
                            :key="route.path" 
                            :id="route.name" 
                            class="main-content" 
                            :class="routesWithoutSpacing.has(route.name) ? '' : 'p-24 md-p-16'"
                        />
                    </Transition>
                </router-view>
            </div>
            <div v-if="routesWithBg.has(route.name)" class="background-overlay-container"></div>
            <div v-if="routesWithBgPayment.has(route.name)" class="background-overlay-container-alt"></div>
        </main>

        <notificationSidebar />

        <!-- <AppFooter /> -->

    </div>

    <main v-else>
        <router-view></router-view>
    </main>

    <AppModal v-model="modalShow" position="center">
        <p class="left-align darklblue fw-regular lh-20 mb-16 p-16">
            <br />
            Hej,
            <br />
            Husk at registrere dine telefonnumre inden mandag d. 16/11-2020
            <br /><br />
            Hos Håndværker.dk vil vi give dine kunder en tryg og sikker oplevelse. Derfor beder vi dig registrere, hvis dit firma bruger mere end ét telefonnummer. Det er en ekstra service til dine kunder, så de ved, når du ringer.
            <br /><br />
            <a href="/ekstraphone" @click="modalShow = false">Klik venligst her og indtast dine telefonnumre</a>
        </p>
    </AppModal>

    <AppModal v-model="modalOnboard" position="center" no-close-on-backdrop>
        <div class="p-16">
            <div class="flex justify-end">
                <el-icon @click="closeOnboardModal()" :size="24" class="cursor-pointer"><Close /></el-icon>
            </div>
            <div class="text-center">
                <svg id="Group_7777" data-name="Group 7777" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54" height="62" viewBox="0 0 54 62">
                    <defs>
                        <clipPath id="clip-path">
                            <rect id="Rectangle_1494" data-name="Rectangle 1494" width="54" height="62" fill="#19a3c0"/>
                        </clipPath>
                    </defs>
                    <g id="Group_7776" data-name="Group 7776" clip-path="url(#clip-path)">
                        <path id="Path_4758" data-name="Path 4758" d="M47.56,91.454a.939.939,0,0,1-.967-.908V75.5a13.263,13.263,0,0,1,.984-5.026.987.987,0,0,1,1.249-.524.892.892,0,0,1,.558,1.173,11.551,11.551,0,0,0-.857,4.377V90.546a.939.939,0,0,1-.967.908" transform="translate(-40.585 -61.426)" fill="#19a3c0"/>
                        <path id="Path_4759" data-name="Path 4759" d="M76.751,30.027a.939.939,0,0,1-.967-.908V14.073a6.988,6.988,0,0,1,13.949,0v1.4a3.447,3.447,0,0,0,3.546,3.33h2.53V14.073c0-6.758-5.855-12.257-13.051-12.257A13.346,13.346,0,0,0,72.626,6.347a1.011,1.011,0,0,1-1.36.132.871.871,0,0,1-.14-1.278A15.324,15.324,0,0,1,82.758,0c8.263,0,14.985,6.313,14.985,14.073v5.642a.939.939,0,0,1-.967.908h-3.5a5.327,5.327,0,0,1-5.48-5.146v-1.4a5.051,5.051,0,0,0-10.081,0V29.119a.939.939,0,0,1-.967.908" transform="translate(-61.766)" fill="#19a3c0"/>
                        <path id="Path_4760" data-name="Path 4760" d="M37.795,266.758H4.19A4.074,4.074,0,0,1,0,262.822V236.9a4.074,4.074,0,0,1,4.19-3.936H26.368a.91.91,0,1,1,0,1.816H4.19A2.194,2.194,0,0,0,1.934,236.9v25.918a2.194,2.194,0,0,0,2.256,2.119h33.6a2.194,2.194,0,0,0,2.256-2.119V236.9a2.194,2.194,0,0,0-2.256-2.119H30.881a.91.91,0,1,1,0-1.816h6.914a4.074,4.074,0,0,1,4.19,3.936v25.918a4.074,4.074,0,0,1-4.19,3.936" transform="translate(0 -204.758)" fill="#19a3c0"/>
                        <path id="Path_4761" data-name="Path 4761" d="M85.12,265.847H63.09w2a.91.91,0,1,1,0-1.816H85.12a.91.91,0,1,1,0,1.816" transform="translate(-54.115 -232.059)" fill="#19a3c0"/>
                        <path id="Path_4762" data-name="Path 4762" d="M87.254,327.157a3.218,3.218,0,0,1-2.216-.862l-2.553-2.4a.87.87,0,0,1,0-1.284,1.012,1.012,0,0,1,1.368,0l2.553,2.4a1.255,1.255,0,0,0,1.7,0l9.628-9.042a1.079,1.079,0,0,0,0-1.594l-1.7-1.592a1.257,1.257,0,0,0-1.7,0l-6.4,6.011a1.012,1.012,0,0,1-1.368,0l-3.227-3.031a1.256,1.256,0,0,0-1.7,0l-1.7,1.592a1.08,1.08,0,0,0,0,1.594l.634.6a.87.87,0,0,1,0,1.284,1.012,1.012,0,0,1-1.368,0l-.634-.6a2.822,2.822,0,0,1,0-4.163l1.7-1.592a3.279,3.279,0,0,1,4.432,0l2.544,2.389,5.717-5.369a3.284,3.284,0,0,1,4.432,0l1.7,1.592a2.818,2.818,0,0,1,0,4.162l-9.628,9.042a3.218,3.218,0,0,1-2.216.862" transform="translate(-67.653 -273.021)" fill="#19a3c0"/>
                        <path id="Path_4763" data-name="Path 4763" d="M345.7,111.968a3.1,3.1,0,0,1-1.48-.375,2.8,2.8,0,0,1-1.383-1.693,2.623,2.623,0,0,1,.3-2.116,2.933,2.933,0,0,1,1.8-1.3l3.869-.973a3,3,0,0,1,3.637,1.972,2.779,2.779,0,0,1-2.1,3.416l-3.868.973a3.166,3.166,0,0,1-.773.1m3.873-4.736a1.1,1.1,0,0,0-.268.033l-3.868.973a1.023,1.023,0,0,0-.629.453.915.915,0,0,0-.1.738.977.977,0,0,0,.482.591,1.087,1.087,0,0,0,.786.1l3.869-.973a.969.969,0,0,0,.732-1.191,1.03,1.03,0,0,0-1-.721" transform="translate(-298.541 -92.65)" fill="#19a3c0"/>
                        <path id="Path_4764" data-name="Path 4764" d="M344.96,187.2a3.188,3.188,0,0,1-.541-.046l-3.8-.654a3.08,3.08,0,0,1-.95-.328,2.7,2.7,0,0,1-.2-4.711,3.1,3.1,0,0,1,2.222-.448l3.8.654a2.972,2.972,0,0,1,1.909,1.159,2.637,2.637,0,0,1,.477,2.087,2.762,2.762,0,0,1-1.234,1.793,3.083,3.083,0,0,1-1.681.495m-3.81-4.416a1.074,1.074,0,0,0-.586.172.943.943,0,0,0,.07,1.643h0a1.072,1.072,0,0,0,.33.114l3.8.654a1.081,1.081,0,0,0,.775-.156.964.964,0,0,0,.43-.625.921.921,0,0,0-.166-.728,1.035,1.035,0,0,0-.665-.4l-3.8-.654a1.1,1.1,0,0,0-.189-.016" transform="translate(-294.579 -159.054)" fill="#19a3c0"/>
                        <path id="Path_4765" data-name="Path 4765" d="M308.009,45.778a3.111,3.111,0,0,1-1.483-.372h0a2.922,2.922,0,0,1-.777-.609,2.676,2.676,0,0,1,.339-3.931l2.944-2.351a3.075,3.075,0,0,1,2.163-.656,3.018,3.018,0,0,1,2.023.973,2.663,2.663,0,0,1,.7,2.031,2.719,2.719,0,0,1-1.036,1.9l-2.944,2.351a3.089,3.089,0,0,1-1.926.663m-.516-1.945a1.092,1.092,0,0,0,1.189-.1l2.944-2.351a.948.948,0,0,0,.361-.663.929.929,0,0,0-.243-.708,1.052,1.052,0,0,0-.706-.34,1.074,1.074,0,0,0-.754.229l-2.944,2.351a.933.933,0,0,0-.118,1.371,1.021,1.021,0,0,0,.271.213" transform="translate(-265.712 -33.266)" fill="#19a3c0"/>
                    </g>
                </svg>
                <div class="fs-16 p-0 mb-16 mt-16">Hej <span class="fw-semibold">{{ companyName }}</span></div>
                <div class="mb-16 fs-16">Din profil er næste klar... Du mangler blot et par få steps, før profilen er klar til brug.</div>
                <div class="mb-16 fs-16">...det tager kun 2 minutter!</div>
                <button @click="goToOnboardingURL()" class="green-button next-button transitionEase fs-16 fw-semibold m-0 lh-20 p-8 rounded-6 block w-100 p-0">Fortsæt</button>
            </div>
        </div>
    </AppModal>

    <paymentreminderpopup @Nopaymentmethod="Nopaymentmethod" ref="paymentreminderpopupRef"></paymentreminderpopup>
    <checkpayproffverify ref="checkpayproffverifyRef"></checkpayproffverify>
    <DynamicStoryPopup />
    
    <DebugBar v-if="!isProd" />
</template>

<script setup>
    import { ElIcon } from 'element-plus'
/* eslint-disable */
    import { ref, computed, watch, onMounted, onBeforeUnmount, defineAsyncComponent } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { Header as AppHeader, Sidebar, Footer as AppFooter } from './components/'
    import AppModal from '@/components/AppModal.vue'
    import paymentreminderpopup from '@/components/paymentreminderpopup'
    import checkpayproffverify from '@/components/checkpayproffverify'
    import DebugBar from '@/components/DebugBar.vue'
import { Close } from '@element-plus/icons-vue'

    const notPaid = defineAsyncComponent(() => import('@/components/notPaid'))
    const DynamicStoryPopup = defineAsyncComponent(() => import('@/components/dynamicStoryPopupv2'))
    const notificationSidebar = defineAsyncComponent(() => import('@/components/Notifications'))

    const route = useRoute()
    const router = useRouter()

    const isProd = ref(['production', 'development'].includes(import.meta.env.MODE))

    // State
    const layoutInitialized = ref(false)
    const modalShow = ref(false)
    const modalOnboard = ref(false)
    const companyName = ref(localStorage.getItem('CompanyName'))
    const nopaymentmethodbool = ref('')
    const dashdata = ref('')

    // Template refs
    const paymentreminderpopupRef = ref(null)
    const checkpayproffverifyRef = ref(null)
    const errorMsgRef = ref(null)

    // Standalone routes that don't need the layout shell
    const standaloneRoutes = new Set([
        'ProjectLogin',
        'Invo',
        'FacebookIntegration',
        'Package',
        'Singupcvr',
        'Signup',
        'SignupAIText',
        'Signupv2',
        'ResetPassword',
        'Inviterepartner',
        'Demo',
        'Demov2',
        'Acceptancemobilepay',
        'Callme',
        'Unsubscribe',
        'Security',
        'ForgotPassword',
        'PartnerSetup',
        'Questionnaire',
        'Questionnaire Thankyou',
        'AbonnementCaptcha'
    ])

    const routesWithBg = new Set([
        'Newsfeed',
        'mycustomer',
        'Privat Udbud2'
    ])
    const routesWithBgPayment = new Set([
        'Paymentmanagement',
    ])

    const routesWithoutSpacing = new Set([
        'draftContract',
        'Webshop',
        'webshopCart',
        'webshopProduct',
        'PrivatMarkedsplads',
        'quickMarkedsplads',
        'cancelContract',
        'UploadTilbud',
        'fastcontract',
        'standardTilbud_forced',
        'StandardTilbudProduct',
        'forcedOfferJob',
        'PriceCalculator',
        'JobPredictions'
    ])

    // Computed
    const showLayout = computed(() => {
        return route.name && !standaloneRoutes.has(route.name)
    })

    // Watch
    watch(() => route.path, () => {
        document.body.classList.remove('sidebar-mobile-show')
    })

    // Layout initialization — runs once when layout first shows
    watch(showLayout, (isLayout) => {
        if (isLayout && !layoutInitialized.value) {
            layoutInitialized.value = true
            // initializeLayout()
        }
    }, { immediate: true })

    // Single click handler that checks the current route reactively.
    const preventOpenCondition = () => route.name === 'mycustomer' && route.query?.isKanvas === 'true'

    const clickHandler = (ev) => {
        try {
            const a = ev.target.closest && ev.target.closest('a')
            
            if (!a || !a.href) return
            if (!a.href.startsWith(window.location.origin)) return

            if (preventOpenCondition()) {
                ev.preventDefault()
                const safeUrl = a.href + (a.href.includes('?') ? '&' : '?') + 'web=1'
                window.location.href = safeUrl
            }
        } catch (e) {
            console.error(e)
        }
    }

    // Methods
    function storageHandler(evt) {
        if (evt.key === 'id_token_portalbitrix') {
            router.push('/security')
        }
    }

    function initializeLayout() {
        const projectPerson = localStorage.getItem('id_token_portalbitrix')
        if (projectPerson === null && route.name !== 'receiveSubcontract') {
            router.push('/login')
        }

        if (localStorage.getItem('email') !== 'simon@imentor.dk' && localStorage.getItem('email') !== 'hossygf@gmail.com' && localStorage.getItem('email') !== 'pn@elternativet.dk' && localStorage.getItem('email') !== 'info@murermesterk.dk' && localStorage.getItem('email') !== 'info@friskmalerservice.dk') {
            setTimeout(function () {
                var els = document.getElementsByTagName('a')
                for (var i = 0, l = els.length; i < l; i++) {
                    var el = els[i]
                    if (el.href.includes('/visitkort')) {
                        els[i].style.display = 'none'
                        els[i].href = '#'
                    }
                    if (el.href.includes('/inviter-en-kollega')) {
                        els[i].style.display = 'none'
                        els[i].href = '#'
                    }
                }
            }, 500)
        }

        if (localStorage.getItem('inhouse') === '1') {
            window.addEventListener('storage', storageHandler, false)
        }

        if (localStorage.getItem('climate') !== 'true') {
            setTimeout(function () {
                var els = document.getElementsByTagName('a')
                for (var i = 0, l = els.length; i < l; i++) {
                    var el = els[i]
                    if (el.href.includes('/klima')) {
                        els[i].style.display = 'none'
                        els[i].href = '#'
                    }
                }
            }, 500)
        }

        if (localStorage.getItem('isadmin') === 'false') {
            setTimeout(function () {
                var els = document.getElementsByTagName('a')
                var pers = JSON.parse(localStorage.getItem('permission'))
                for (var i = 0, l = els.length; i < l; i++) {
                    var el = els[i]
                    var permission = null
                    if (el.href.includes('/newsfeed')) {
                        for (var j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'newsfeed' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/markedsplads')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'marketplace' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/mester-arbejdskraft')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'm2m' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/mester-opgaver')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'm2m' && permission.value === '0') {
                                var menu = document.getElementById('dropMester-til-Mester')
                                menu.style.display = 'none'
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/settings')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'settings' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/alle-moeder')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'your_client' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/inbox')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'message' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/indhent-anbefalinger') || el.href.includes('/laes-og-besvar-anbefalinger') || el.href.includes('/auto-anbefalinger') || el.href.includes('/widgets')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'recommendations' && permission.value === '0') {
                                var menua = document.getElementById('dropAnbefalinger')
                                menua.style.display = 'none'
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/opret-projekt-new')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'projects' && permission.value === '0') {
                                var menup = document.getElementById('dropDine projekter')
                                menup.style.display = 'none'
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/status-haandvaerker-new')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'projects' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/chat')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'chat' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/offer')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'make_an_offer' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                    if (el.href.includes('/contact_us')) {
                        for (j = 0, z = pers.length; j < z; j++) {
                            permission = pers[j]
                            if (permission.module === 'contact_us' && permission.value === '0') {
                                els[i].style.display = 'none'
                                els[i].href = '#'
                            }
                        }
                    }
                }
            }, 500)
        }

        if (localStorage.getItem('onlycredit') === '1') {
            setTimeout(function () {
                var els = document.getElementsByTagName('a')
                for (var e = 0, r = els.length; e < r; e++) {
                    if (!els[e].href.includes('/login') && !els[e].href.includes('kredit') && !els[e].href.includes('kreditkort')) {
                        els[e].style.display = 'none'
                        els[e].href = '#'
                    }
                }
                var element = document.getElementById('dropAnbefalinger')
                element.style.display = 'none'
                element = document.getElementById('dropDine projekter')
                element.style.display = 'none'
                element = document.getElementById('dropMester-til-Mester')
                element.style.display = 'none'
                element = document.getElementById('dropWebshop')
                element.style.display = 'none'
                element = document.getElementById('dropOpret tilbud')
                element.style.display = 'none'
            }, 500)
        }
    }

    // Lifecycle
    onMounted(() => {
        if (import.meta.env.MODE === 'production' && typeof window.fbq === 'function') {
            window.fbq('track', 'PageView')
        }
        document.addEventListener('click', clickHandler, true)
    })

    onBeforeUnmount(() => {
        window.removeEventListener('storage', storageHandler, false)
        document.removeEventListener('click', clickHandler, true)
    })

    // Modal init
    if (localStorage.getItem('pendingOnboarding') === 'yes') {
        // modalOnboard.value = true
    }
    if (!localStorage.getItem('ads9')) {
        setTimeout(function () {
            modalShow.value = false
        }, 1500)
        localStorage.setItem('ads9', 'true')
    }

    // Modal methods
    function goToOnboardingURL () {
        let onboardingUrl = localStorage.getItem('onboardingURL')
        window.open(onboardingUrl, '_blank').focus()
        closeOnboardModal()
    }

    function closeOnboardModal () {
        modalOnboard.value = false
        localStorage.setItem('pendingOnboarding', 'no')
    }

    // Payment reminder
    dashdata.value = route.query.dashdata

    watch(nopaymentmethodbool, (newVal) => {
        if (newVal === 'true') {
            Nopaymentmethod()
        }
        if (newVal === 'false') {
            paymentreminderpopupRef.value.hidemodalinitial()
            paymentreminderpopupRef.value.hidemodal()
            var reminderbar = document.getElementById('reminderbarmain')
            reminderbar.classList.add('hide')
            var bar = document.getElementById('mainNavbar')
            bar.style.marginTop = '0px'
        }
    })

    function Nopaymentmethod (method) {
        nopaymentmethodbool.value = method
        if (nopaymentmethodbool.value === 'true') {
            openpaymentreminder()
        }
    }

    function openpaymentreminder () {
        paymentreminderpopupRef.value.showmodalinitial()
        setwarning()
    }

    function setwarning () {
        if (nopaymentmethodbool.value) {
            var reminderbar = document.getElementById('reminderbarmain')
            reminderbar.style.marginTop = '0px'
            reminderbar.style.position = 'fixed'
            reminderbar.style.zIndex = '1026'
            reminderbar.classList.remove('hide')
            var navbar = document.getElementById('mainheader')
            navbar.style.borderBottom = '0px'
            navbar.style.position = 'none'
            navbar.classList.remove('navbar')
            navbar.classList.remove('app-header')
            var bar = document.getElementById('mainNavbar')
            bar.style.position = 'fixed'
            bar.style.zIndex = '1026'
            bar.style.backgroundColor = '#fff'
            bar.style.marginTop = '26px'
            bar.style.borderBottom = '1px solid #d1d4d7'
        }
    }
</script>

<style lang="scss" scoped>

    .app-body {
        display: block;
    }

    #main-container {
        margin-left: 340px;
        width: calc(100% - 340px);
        min-height: calc(100vh - 55px);
        overflow: hidden;
        position: relative;
        transition: margin-left 0.15s cubic-bezier(1, 0.5, 0.8, 1), width 0.15s cubic-bezier(1, 0.5, 0.8, 1);

        @media only screen and (max-width: 1024px) {
            width: calc(100% - 300px);
            margin-left: 300px;
        }

        @media only screen and (max-width: 990px) {
            min-width: 100vw;
            width: unset;
        }
    }

    .sidebar-hidden #main-container {
        margin-left: 0;
        width: 100%;
    }

    @media (max-width: 1024px) {
        #main-container {
            margin-left: 0;
            width: 100%;
        }
    }

    .background-overlay-container {
        z-index: -1;
        display: block;
        position: fixed;
        transition: all 0.2s ease;
        left: 340px;
        top: 0;
        width: calc(100% - 340px);
        background-image: 
            radial-gradient(circle 1000px at top left, #19A3C060, transparent 60%),
            radial-gradient(circle 1500px at bottom right, #19A3C060, transparent 80%);
        background-color: #F8FAFA;
        height: 100%;

        @media only screen and (max-width: 1024px) {
            left: 300px;
            width: calc(100% - 300px);
        }
        @media only screen and (max-width: 1024px) {
            width: 100%;
            left: 0;
        }
    }

    .background-overlay-container-alt {
        z-index: 0;
        display: block;
        position: fixed;
        transition: all 0.2s ease;
        left: 340px;
        top: 0;
        width: calc(100% - 340px);
        background-color: rgb(25, 163, 192);
        background: linear-gradient(0deg, rgb(25, 163, 192) 0%, rgb(139, 235, 255) 100%);
        height: 100%;

        @media only screen and (max-width: 1024px) {
            width: 100%;
            left: 0;
        }
    }

    .main-content {
        position: relative;
        overflow-y: overlay;
        height: calc(100svh - 55px);

        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

        &::-webkit-scrollbar {
            width: 6px;
            z-index: 9999;
        }
        &::-webkit-scrollbar-track {
            background: #F8FAFA;
        }
        &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.2);
            border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background-color: rgba(0, 0, 0, 0.35);
        }

        @media only screen and (max-width: 620px) {
            max-height: none !important;
            scrollbar-width: none !important;
            -ms-overflow-style: none !important;
            &::-webkit-scrollbar {
                display: none !important;
                width: 0 !important;
            }
            &::before {
                width: 100% !important;
            }
        }
    }
</style>
